import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-vendor',
  templateUrl: './delete-vendor.component.html',
  styleUrls: ['./delete-vendor.component.css']
})
export class DeleteVendorComponent implements OnInit {

  modelSubtitle = false
  product:any = []
  deleteId: any = "";

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getallVendor()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallVendor()
  }
  
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallVendor(){
    // this.generic_service.getVendor().subscribe(
    //   (response:any)=>{
    //     console.log(response)
    //     this.product = response.response;
    //     this.totalRecords = response.response.length;
    //   }
    // )
  }
 
  deleleVendor(){
    this.generic_service.delVendor(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getallVendor();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}
